<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-img
        :src="require('@/assets/logo_largo_white_r2.svg')"
        contain
        max-width="128"
        min-height="78"
        width="100%"
      />

      <base-title
        size="body-1"
        space="4"
        title="PROYECTOS E INSTALACIONES"
        weight="regular"
      />

      <base-body>
        Fundada en el año 2005 con más de {{ new Date().getFullYear() - 2005 }} años de experiencia en la realización de obras en el sector industrial, comercial y residencial, destaca por el compromiso y rigurosidad en el cumplimiento de plazos y calidad del producto final.
      </base-body>

      <base-btn
        class="mb-12"
        color="white"
        outlined
      >
        <!-- Saber más -->
        <a
          style="color:white"
          target="_blanck"
          href="https://firebasestorage.googleapis.com/v0/b/rosmar-web.appspot.com/o/Dosier_Digital_Rosmar.pdf?alt=media&token=de5443b9-7d37-4b10-8690-d7896c97393c"
        >
          Dossier Empresa
        </a>
      </base-btn>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseInfo',

    props: {
      title: String,
      dark: Boolean,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Address',
          text: '8888 N. Beach St. Ste. 227<br>Fort Worth, Texas 76137',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: '01 (800) 433 744<br>01 (800) 433 633',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'john@vuetifyjs.com<br>heather@vuetifyjs.com',
        },
      ],
    }),
  }
</script>
